export default __webpack_public_path__ + "8a1e2394d721036f5f64d584b94e9e37.png";